export default __webpack_public_path__ + "static/media/calendar.5a67046b.svg";